import { render } from "./FooterUzgent.vue?vue&type=template&id=a84e5d02&scoped=true"
import script from "./FooterUzgent.vue?vue&type=script&lang=js"
export * from "./FooterUzgent.vue?vue&type=script&lang=js"

import "./FooterUzgent.vue?vue&type=style&index=0&id=a84e5d02&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a84e5d02"]])

export default __exports__